<template>
  <div class="materialPurchase">
     <div class="content-container">
      <div class="titieMian">
        <div class="title-container">物资采购</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>基地&nbsp;&nbsp;</span>
            <el-select v-model="fishBaseId"  filterable placeholder="请选择"  size="small" @change="baseChange">
              <el-option
                v-for="(item, index) in baseList"
                :key="index"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-date-picker
              size="small"
              v-model="start"
              type="date"
              :clearable="false"
              placeholder="开始日期"
                @change="changeTime(0)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker
              size="small"
              v-model="end"
              type="date"
              :clearable="false"
              placeholder="结束日期"
              @change="changeTime(1)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box">
            <span>在&nbsp;&nbsp;</span>
            <el-select v-model="type" filterable  size="small">
              <el-option
                v-for="(item, index) in typeList"
                :key="index"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>查找&nbsp;&nbsp;</span>
            <el-input placeholder="请输入关键字" v-model="keyword" prefix-icon="el-icon-search" size="small" type="text" :maxlength="20" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" class="search-input" clearable>
            </el-input>
          </div>
          <div class="select-container-box"  v-if="canEditAll=true">
            <el-button size="small" type="info" plain @click="goSearch(1)" class="query" >查询</el-button>
             <el-button size="small" type="info" plain @click="goAdd" class="add" v-if="edit==true">增加</el-button>
          </div>
        
        </div>
      </div>
      <div class="table-container">
        <el-table
         :data="materialPurchaseList.list"
          style="width:100%" 
          @row-dblclick="dataBackFillGoods"
          :summary-method="getSummaries"
          show-summary
          size="medium" 
          :default-sort="{prop: 'date', order: 'descending'}">
           <i slot="empty" style="font-style:normal">该时间段暂无数据</i>
            <el-table-column
            prop="date"
            label="日期"
            show-overflow-tooltip 
            :formatter="formatter"
            align="center"
            >
          </el-table-column>
          <el-table-column
           prop="category" 
           label="物资大类"
           :filters="getFilterTypeList"
           :filter-method="filterHandler" 
           align="center"
           show-overflow-tooltip 
          >
          </el-table-column>
          <el-table-column 
          prop="type" 
          label="物资类型"
          :filters="getFilterTypesList"
          :filter-method="filterHandler" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
           <el-table-column 
          prop="name" 
          label="物资名称" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="spec" 
          label="规格" 
          show-overflow-tooltip 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="unit" 
          label="计量单位" 
          align="center">
          </el-table-column>
          <el-table-column 
          prop="quantity" 
          label="数量" 
          width="140"
          show-overflow-tooltip 
          align="center">
          </el-table-column>
           <el-table-column 
          prop="price" 
          label="单价(元)" 
          align="center">
          </el-table-column>
           <el-table-column 
          prop="amount" 
          label="结算金额(元)" 
          width="140"
          show-overflow-tooltip 
          align="center">
          </el-table-column> 
          <el-table-column 
          prop="leader" 
          label="经办人" 
          align="center">
          </el-table-column>
          <el-table-column label="操作栏" align="center"  >
            <template slot-scope="scope">
              <span @click="baseSettingEdit(scope.$index, scope.row)" class="content-edit" >{{edit?"编辑":"查看"}}</span>
              <span @click="baseSettingDelete(scope.$index, scope.row)" class="content-del"  v-if="edit">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <page-change :pageInfo="pageInfo"></page-change>
    </div>
  </div>
</template>


<script>
import PageChange from "../../common/PageChange";
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import { storage } from "../../../service/storage";
import checkPermission from "../../../service/checkPermission.js";
import mixins from "@/common/MixIn.js";
export default {
  name: "materialPurchase",
  mixins: [mixins],
  components: {
    PageChange
  },
  data() {
    return {
      edit: "",
      start: "", //开始时间
      end: "", //结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      fishBaseId: "", //基地
      baseList: [], //基地列表
      type: "",
      typeList: [
        {
          value: "",
          label: "全部"
        },
        {
          label: "饲料",
          value: "10001"
        },
        {
          label: "渔药",
          value: "10002"
        },
        {
          label: "疫苗",
          value: "10003"
        }
      ],
      keyword: "", //查找
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        pageFunc: this.goSearch, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    };
  },
  //默认时间
  created() {
    let startTime = storage.get("start");
    let endTime = storage.get("end");
    if (startTime) {
      this.start = startTime;
    } else {
      const start = new Date();
      start.setDate(1);
      this.start = this.$timeformatDay(start);
    }
    if (endTime) {
      this.end = endTime;
    } else {
      this.end = this.$timeformatDay(new Date());
    }
  },
  methods: {
    ...mapActions(modules.materialPurchase, [
      "getMaterialPurchaseData",
      "delMaterialPurchaseDetail"
    ]),
    ...mapActions(modules.base, ["getAllBaseList"]), //基地
    //记住基地
    baseChange(e) {
      storage.set("base", e);
    },
    // 字段筛选过滤
    filterHandler(value, row, column) {
      const property = column["property"];
      return row[property] === value;
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.start);
      } else {
        storage.set("end", this.end);
      }
    },
    // 格式化指定列时间
    formatter(row) {
      if (!row.date) {
        return false;
      }
      return this.$timeformatDay(row.date);
    },
    //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          index === 1 ||
          index === 2 ||
          index === 3 ||
          index === 4 ||
          index === 7
        ) {
          sums[index] = "--";
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    //双击进入编辑页面
    dataBackFillGoods(row, event) {
      this.$router.push({
        name: "addMaterialPurchase",
        query: {
          id: row.orderId,
          edit: this.edit
        }
      });
    },
    //查询
    async goSearch(pageNum) {
      // 设置sessionStorage
      sessionStorage.setItem("MaterialPurchaseKeyword", this.keyword);
      let obj = {
        pageIndex: (this.pageInfo.pageNumber = pageNum || 1),
        pageSize: this.pageInfo.pageSize,
        fishBaseId: this.fishBaseId,
        startDate: this.start,
        endDate: this.end,
        category: this.type,
        queryString: this.keyword
      };
      if (this.fishBaseId !== "") {
        obj.fishBaseId = this.fishBaseId;
      }
      if (this.type !== "") {
        obj[this.type] = this.keyword;
      }

      this.getMaterialPurchaseData(obj)
        .then(rsp => {
          if (rsp.status === 200) {
            this.pageInfo.totalPages = rsp.data.total;
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //同步
    goExport() {},
    // 添加
    goAdd() {
      this.$router.push({
        name: "addMaterialPurchase",
        query: {
          edit: this.edit
        }
      });
    },
    //编辑
    baseSettingEdit(index, row) {
      this.$router.push({
        name: "addMaterialPurchase",
        query: {
          id: row.orderId,
          edit: this.edit
        }
      });
    },

    //删除
    baseSettingDelete(index, row) {
      let pageIndex = this.pageInfo.pageNumber;
      if (this.pageInfo.totalPages % 10 === 1) {
        pageIndex -= 1;
      }
      this.$confirm("是否删除此记录", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          await this.delMaterialPurchaseDetail(row.id);
          this.goSearch(pageIndex);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(err => {
          this.$Alert.info({
            content: err.response.data,
            duration: 5000,
            status: "error"
          });
          // this.$message.error(err.response.data);
        });
    },
    isPermiss() {
      //权限判断
      if (
        this.companyList.isQlwVersion == false ||
        this.companyList.isQlwVersion == null
      ) {
        let permission = this.loginUser.permissions.find(item => {
          return item.permissionId == this.permission.materialPurchase;
        });
        if (permission) {
          this.edit = !permission.isReadOnly;
        }
      } else if (this.companyList.isQlwVersion == true) {
        checkPermission.checkEdit(this.$route).then(data => {
          this.edit = true;
        });
      }
    }
  },
  computed: {
    // 获取 是否为企联网
    whetherQlw() {
      return this.companyList.isQlwVersion;
    },
    ...mapState(modules.materialPurchase, ["materialPurchaseList"]),
    //需要筛选的字段
    getFilterTypeList() {
      const res = new Map();
      let fiterList = this.materialPurchaseList.list
        .map(m => ({
          value: m.category,
          text: m.category
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    },
    //需要筛选的字段
    getFilterTypesList() {
      const res = new Map();
      let fiterList = this.materialPurchaseList.list
        .map(m => ({
          value: m.type,
          text: m.type
        }))
        .filter(a => !res.has(a.text) && res.set(a.text, 1));
      return fiterList;
    }
  },
  watch: {
    // 监听isQlwVersion
    whetherQlw(val) {
      this.isPermiss();
    }
  },
  async mounted() {
    this.isPermiss();
    let baseList = await this.getAllBaseList(); //基地
    this.baseList = [
      {
        key: "",
        value: "全部"
      }
    ].concat(baseList);
    // sessionstorage记住查找关键字
    this.judgeSession("MaterialPurchaseKeyword");
    this.keyword = this.word;
    // 记住选中基地;
    let materialPurchaseBase = storage.get("base");
    let oldBase = this.baseList.find(f => f.key == materialPurchaseBase);
    if (oldBase) {
      this.fishBaseId = oldBase.key;
    } else if (this.baseList.length > 0) {
      this.fishBaseId = this.baseList[0].key; //默认选中第一个
    }
    this.goSearch();
  }
};
</script>

<style lang="stylus">

</style>
